._Header_18zgq_1 {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
